import { z } from "zod"

import {
  GlAccountBalance,
  GlAccountClassification,
  GlAccountCurrency,
  GlAccountSubType,
  GlAccountType,
  ReportingAccountType,
} from "@/graphql/codegen/graphql"

export const glAccountFormSchema = z
  .object({
    reportingAccountType: z.nativeEnum(ReportingAccountType),
    parentGlAccountId: z.string().nullish(),
    company: z.string(),
    costCenter: z.number().int().positive().nullish(),
    number: z.number().int().positive().max(9999),
    subNumber: z.number().int().min(0).max(99).nullable().optional(),
    type: z.nativeEnum(GlAccountType).nullish(),
    subType: z.nativeEnum(GlAccountSubType).nullish(),
    classification: z.nativeEnum(GlAccountClassification).nullish(),
    currency: z.nativeEnum(GlAccountCurrency),
    balance: z.nativeEnum(GlAccountBalance).optional(),
    title: z.string().min(1, "Account Title is required").max(35, "Account Title must be 35 characters or less"),
    description: z.string().max(50, "Description must be 50 characters or less").optional(),
  })
  .superRefine((values, ctx) => {
    if (values.reportingAccountType === ReportingAccountType.Posting && !values.parentGlAccountId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Parent Account is required for posting accounts",
        path: ["parentGlAccountId"],
      })
    }
  })

export type GlAccountFormValues = z.infer<typeof glAccountFormSchema>
